import {Injectable} from '@angular/core';
import {GfxHttpSrv} from './GfxHttpSrv';
import {ISelectNgxMat} from '../components/gfx-ngx-mat-select-search/gfx-ngx-mat-select-search.component';

@Injectable({
    providedIn: 'root',
})
export class RefsService {

    constructor(private http: GfxHttpSrv) {
    }

    getProfilById(id) {
        return this.http
            .getPathParams('portal/refs/profil', id);
    }
    getRoleById(id) {
        return this.http.getPathParams("portal/roles", id);
    }

    getNatio() {
        return this.http.get('mainApp/refs/natio');
    }
    getPays() {
        return this.http.get('mainApp/refs/nationalite');
    }

    getPostComptaReg() {
        return this.http.get("mainApp/refs/posteComptaReg");
    }

    getAgenceBanque() {
        return this.http.get("mainApp/refs/agenceBanc");
    }


    prepareSelectSetting(
        placeHolder,
        required?: boolean,
        displKey?: any
    ): ISelectNgxMat {
        return {
            data: [],
            placeHolder: placeHolder,
            displKey: displKey ? displKey : 'lib',
            required: required,
            disabled: false,
        };

    }


    getRubriquesCalcul() {
        return this.http.get('portal/refs/rubriquesCalcul');
    }

    getUsersByProfilLiq() {
        return this.http.get("portal/refs/usersByProfilLiq");
    }

    getActes() {
        return this.http.get('mainApp/refs/actes');
    }

    getMotifReclamation() {
        return this.http.get('portal/refs/motifReclamation');
    }

    getModeSaisine() {
        return this.http.get('portal/refs/modeSaisine');
    }

    getTypeDossierPrincipal() {
        return this.http.get('portal/refs/typeDossierPrincipal');
    }
}

export interface IRefSelect {
    id;
    lib;
    code;
}
